import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, ParamMap, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateTime } from 'luxon';
import { UserProfile } from 'src/app/interfaces/UserProfile';
import { DriverReportView } from 'src/app/interfaces/driverReportView';
import RenderDriverReportRequest from 'src/app/interfaces/renderReportRequest';
import { AuditService } from 'src/app/services/audit.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { DriverRecordRequestService } from 'src/app/services/driverrecordrequest.service';
import { GeneralService } from 'src/app/services/general.service';
import { RecordsService } from 'src/app/services/records.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-byauthcode',
    templateUrl: './byauthcode.component.html',
    styleUrls: ['./byauthcode.component.scss'],
    standalone: false
})
export class ByauthcodeComponent {
  authCode: string = '';
  isOnProbation: boolean = false;
  isChecked: boolean = false;
  isSaving: boolean = false;
  isLoading: boolean = false;
  isUploading: boolean = false;
  userProfile?: UserProfile;
  hasConfirmedConsent: boolean = false;
  probationTransApproved: boolean = false;
  submittalType: string = "";
  showMustConsent: boolean = false;
  showValidationMessage: boolean = false;
  showPendingUnderReview: boolean = false;
  showProbationUpload: boolean = false;
  showCanViewRecord: boolean = false;
  showExpiredOrError: boolean = false;
  showFaxOrUploadModal: boolean = false;
  showResubmitModal: boolean = false;
  showUploadModal: boolean = false;
  transactionData: any = {};
  allowDocumentSubmissionContinue: boolean = false;
  username: string = '';
  pdfUrl: string = "";
  probationDocuments: any = [];
  consentUpdated: boolean = false;
  message: string = `${this.translate("default_driver_record_error")}`;
  isResubmit: boolean = false;
  isValidFileType: boolean = true;
  authMethod: string = 'Login.gov';
  accessedVia: string = 'IAHbyAuthCode';
  routeParams: ParamMap = {} as ParamMap;
  currentRoute: string = '';
  invFileTypeModal: any;

  
  @ViewChild('UploadModal')
  uploadModal!: TemplateRef<any>;

  @ViewChild('InvalidFileTypeModal')
  invalidFileTypeModal!: TemplateRef<any>;

  constructor(private router: Router,
    private auditService: AuditService,
    private generalService: GeneralService,
    private recordsService: RecordsService,
    private driverRecordRequestService: DriverRecordRequestService,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private modalService: NgbModal) { 
        this.authCode = this.router.url.split('/')[2];
        authenticationService.setDeepLinkResolved(true);
        authenticationService.setDeepLink('');
    }
  
  ngOnInit() {
      this.isLoading = true;

      this.username = this.authenticationService.getUserName();
      this.userProfile = this.authenticationService.getUserProfile() as UserProfile;

      if (!this.userProfile) {
          this.router.navigateByUrl('/signin');   
      } else if (this.userProfile!.userData.roles.includes("csr_admin") || this.userProfile!.userData.roles.includes("csr_user")) {
          window.location.href = environment?.APP_PSP_NEXT_URL + 'csr/customers';
      } else if (this.userProfile!.userData.roles.includes("driver")) {
          this.router.navigateByUrl('/driverDashboard')
      } 

       // obtain the probation status of this customer.
       if (this.userProfile && this.userProfile.customer && this.userProfile.customer.auditPenalty &&
            this.userProfile!.customer!.auditPenalty!.penaltyStartDate &&
            this.userProfile!.customer!.auditPenalty!.penaltyEndDate) {
            const nowMoment = DateTime.now();
            const start = DateTime.fromISO(this.userProfile!.customer!.auditPenalty!.penaltyStartDate.toString());
            const end = DateTime.fromISO(this.userProfile!.customer!.auditPenalty!.penaltyEndDate.toString());
            if (this.userProfile!.customer!.auditPenalty!.auditPenaltyActionId === 1 &&
                 start <= nowMoment && end >= nowMoment) {
                 this.isOnProbation = true;
            }
       }

      // grab the transaction using the Dashboard API and passing in the authCode as searchText
      const recordsPromise = this.recordsService.getAccountHolderRecords(1, 1, '', '', this.username, this.authCode);
      recordsPromise
          .then((response: any) => {
              this.transactionData = [];
              if (response && response.items && response.items.length > 0) {
                  this.transactionData = response!.items[0];
                  if (!this.isValidTransaction()) {
                      this.message = `${this.translate("default_driver_record_error")}`;
                      this.showExpiredOrError = true;
                  } else {            
                      // check if on probation and has uplaoded consent
                      if (!this.isOnProbation) {
                          if (!this.transactionData!.driversConsent) {
                              this.showMustConsent = true;
                          } else {
                              this.showCanViewRecord = true;
                          }
                      } else {
                          // check if probation documents are uploaded
                          if (this.transactionData.probationStatusId === '1') {
                              // Open
                              if (this.transactionData.documentId && this.transactionData.documentId.length > 0) {
                                  // has an upload
                                  this.showPendingUnderReview = true;
                              } else {
                                  // does not have an upload
                                  this.showMustConsent = true;
                              }
                          } else if (this.transactionData.probationStatusId === '2') {
                              // Exception
                              this.message = `${this.translate("default_driver_record_error")}`;
                              this.showExpiredOrError = true;
                          } else if (this.transactionData.probationStatusId === '3') {
                              // Accepted
                              this.showCanViewRecord = true;
                          } else if (this.transactionData.probationStatusId === '4') {
                              // Not Accepted (resubmit)
                              this.isResubmit = true;
                              this.showProbationUpload = true;
                          } else {
                            this.showCanViewRecord = true;
                          }
                      }
                  }

                  this.isLoading = false;

              } else {
                  // No transaction found
                  this.isLoading = false;
                  this.message = `${this.translate("default_driver_record_error")}`;
                  this.showExpiredOrError = true;
              }
          })
          .catch((error: any) => {
              console.error(error);
              this.isLoading = false;
              this.transactionData = [];
              this.message = `${this.translate("default_driver_record_error")}`;
              this.showExpiredOrError = true;
          });
  }

  get authCodeString() {
      return this.authCode;
  }

  setFocus(el:any) {
      try{
      if (el.$el.getElementsByTagName('input').length === 4) {
          el.$el.getElementsByTagName('input')[3].focus();
      }}catch(e){
          console.error(e)
      }
  }

  toDashboard() {
      this.authenticationService.setDeepLink('');
      this.router.navigateByUrl('/dashboard');
  }

  isValidTransaction(): boolean {
      let ret_val: boolean = false;
      if (this.transactionData.custId === this.userProfile!.customer!.customerId?.toString()
          || this.transactionData.motorCarrierId === this.userProfile!.customer!.customerId?.toString()) {
          ret_val = true;
      } else {
          ret_val = false;
      }
      return ret_val
  }

  submit() {
      if (!this.hasConfirmedConsent) {
          this.showValidationMessage = true;
          return;
      }
      this.isSaving = true;
      this.showValidationMessage = false;
      const updateDriverConsentPromise = this. recordsService.updateDriverConsent(this.authCode, this.hasConfirmedConsent);
      updateDriverConsentPromise.then((result: boolean | any) => {
          if (result) {
              this.isSaving = false;
              this.consentUpdated = true;
              this.clearShowUiFlags();
              this.authenticationService.setDeepLink('');

              // check if on probation and has uplaoded consent
              if (!this.isOnProbation) {
                  this.showCanViewRecord = true;
              } else {
                  // check if probation documents are uploaded
                  if (this.transactionData.probationStatusId === '1') {
                      // Open
                      if (this.transactionData.documentIds && this.transactionData.documentIds.length > 0) {
                          // has an upload
                          this.showPendingUnderReview = true;
                      } else {
                          // does not have an upload
                          this.showProbationUpload = true;
                      }
                  } else if (this.transactionData.probationStatusId === '2') {
                      // Exception
                      this.message = `${this.translate("default_driver_record_error")}`;
                      this.showExpiredOrError = true;
                  } else if (this.transactionData.probationStatusId === '3') {
                      // Accepted
                      this.showCanViewRecord = true;
                  } else if (this.transactionData.probationStatusId === '4') {
                      // Not Accepted
                      this.showExpiredOrError = true;
                      this.message = `${this.translate("default_driver_record_error")}`;
                  }
              }
          }
          else {
              /* This is most likely an unauthorized error. The user's customer did not match the transactions motor carrier id. */
              this.router.navigateByUrl('/accessDenied');
          }
      })
          .catch((error: any) => {
              this.isSaving = false;
              this.message = `${this.translate("default_driver_record_error")}`;
              this.showExpiredOrError = true;
          });
  }

  clearShowUiFlags() {
      this.showMustConsent = false;
      this.showValidationMessage = false;
      this.showPendingUnderReview = false;
      this.showProbationUpload = false;
      this.showCanViewRecord = false;
      this.showExpiredOrError = false;
      this.showFaxOrUploadModal = false;
      this.showResubmitModal = false;
      this.showUploadModal = false;
  }

  showInBrowser() {
      const request: RenderDriverReportRequest = { asPdf: false, authCode: this.authCode, driverIP: '' };
      this.driverRecordRequestService.getEndUserIp()
          .then((result:any) => {
              request.driverIP = result;
              const reportView: DriverReportView = {
                  accessedVia: this.accessedVia,
                  accessedBy: this.username,
                  accessorCustomerId: this.userProfile!.customerId,
                  authCode: this.authCode,
                  authenticationMethod: this.authMethod, 
                  accessedDateTime: DateTime.now().toJSDate()
              }
              this.driverRecordRequestService.openDriverReport(request, reportView)
                  .then((v: any) => {
                      this.openInBrowser(v);
                  })
                  .catch((error: any) => {
                      console.error(error);
                  });
          }).catch((error:any) => {
              console.error(error);
              const reportView: DriverReportView = {
                  accessedVia: this.accessedVia,
                  accessedBy: this.username,
                  accessorCustomerId: this.userProfile!.customerId,
                  authCode: this.authCode,
                  authenticationMethod: this.authMethod, 
                  accessedDateTime: DateTime.now().toJSDate()
              }
              this.driverRecordRequestService.openDriverReport(request, reportView)
                  .then((v: any) => {
                      this.openInBrowser(v);
                  })
                  .catch((error: any) => {
                      console.error(error);
                  });
          });
  }

  openInBrowser(contentToRender: string) {
      if (contentToRender && contentToRender.length === 0) {
          this.router.navigateByUrl('/customerSupportInfo');
      }
      const newWindow = window.open();
      if (newWindow) {
          newWindow.document.write(contentToRender);
          newWindow.document.close();
          newWindow.focus()
      }
  }

  downloadPdf() {
      const reportView: DriverReportView = {
          accessedVia: this.accessedVia,
          accessedBy: this.username,
          accessorCustomerId: this.userProfile!.customerId,
          authCode: this.authCode,
          authenticationMethod: this.authMethod, 
          accessedDateTime: DateTime.now().toJSDate()
      }
      this.driverRecordRequestService.getDriverReportPdf(this.authCode, reportView)
          .then((v: any) => this.openPdf(v))
          .catch((error: any) => {
              console.error(error);
          });
  }

  openPdf(buffer: any) {
      const filename = "DriverReport.pdf";
      const element = document.createElement('a');
      element.setAttribute('href','data:application/octet-stream;base64,' + buffer);
      element.setAttribute('download',filename);
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
  }

  openSubmitDialog() {
    this.modalService.open(this.uploadModal, { size: 'lg', ariaLabelledBy: 'uploadModalTitle' });
      this.showUploadModal = true
  }
  
  selectFaxOrUpload() {
      this.showFaxOrUploadModal = false;
      this.allowDocumentSubmissionContinue = false;
      if (this.submittalType === 'online') {
          this.showUploadModal = true;
          this.submittalType = '';
      } else {
          this.isLoading = true;
          this.submittalType = '';
          const auditServicePromise = this.auditService.getFaxCoverSheet(this.authCode);
          auditServicePromise.then((result: any | any) => {
              this.isLoading = false;
              const faxWindow = window.open('', '', 'width=800,height=600,resizable=1');
              faxWindow?.document.write(result);
              faxWindow?.focus();
          })
          .catch((error: any) => {
              console.error(error);
          });
          this.isLoading = false;
      }
  }

  cancelFaxOrUploadModal() {
      this.allowDocumentSubmissionContinue = false;
      this.submittalType = '';
      this.showFaxOrUploadModal = false;
  }

  removeDocument(docId: string) {
      this.auditService.removeDocument(docId, this.authCode)
          .then((result: any) => {
              if (result && result === 'unauthorized') {
                  console.error('User not authorized to delete document.');
                  this.router.navigateByUrl('/accessDenied');
              } else if (result && result.length > 0) {
                  this.probationDocuments.splice(this.probationDocuments.indexOf(docId), 1);
              } else {
                  console.error('Error occurred deleting document');
                  this.router.navigateByUrl('/applicationException');
              }
          }).catch((error: any) => {
              console.error('Error deleting document.');
              console.error(error);
              this.router.navigateByUrl('/applicationException');
          });
  }

  generateFaxCoverSheet() {
    this.isLoading = true;
    const thisWindow = window;
    const auditServicePromise = this.auditService.getFaxCoverSheet(this.authCode)
    .then((result: any | any) => {
        this.isLoading = false;
        const faxWindow = thisWindow.open('', '', 'width=800,height=600,resizable=1');
        faxWindow?.document.write(result.data);
        faxWindow?.focus();
        thisWindow.onbeforeunload = null;
    })
    .catch((error: any) => {
        console.error(error);
        thisWindow.onbeforeunload = null;
    });
    this.isLoading = false;
  }

  cancelUploads() {
      //if the upload modal is dismissed in this way we must remove the documents that may have been uploaded
      this.isLoading = true;
      
      this.probationDocuments.forEach((doc: any) => {
          this.auditService.removeDocument(doc.documentId, this.authCode);
      });
      this.probationDocuments = [];

      this.isLoading = false;
      this.showUploadModal = false;
      this.modalService.dismissAll();
  }

  completeDocumentUploads() {
      if (this.isResubmit) {
          // update probation transaction to show resubmit state ('Open' with upload document)
          this.isLoading = true;
          this.auditService.updateProbationTransactionStatus(this.authCode, 1).then((result: any) => {
              this.isLoading = false;
          });
      }

      this.auditService.sendProbationUploadEmail(this.transactionData.firstName, this.transactionData.lastName, this.transactionData.requestDate).then((result: any) => {
          this.isLoading = false;
      });

      this.showUploadModal = false;
      this.clearShowUiFlags();
      this.showPendingUnderReview = true;
      this.modalService.dismissAll();
  }

  showDocument(documentId: string) {
    const docUrl = `${environment.APP_API_URL}/Documents/${documentId}`;
    window.open(docUrl, '', 'width=800,height=600,resizable=1');
    //this.$viewerApi({ images: [docUrl] });
}

  showPdfDocument(documentId: string) {
      this.pdfUrl = `${environment.APP_API_URL}/Documents/${documentId}`;
      //this.showPdfModal = true;
      window.open(this.pdfUrl, '', 'width=800,height=600,resizable=1');
  }

  getPDFDocumentUrl(documentId: string) {
      return `${environment.APP_API_URL}/Documents/${documentId}`;
  }

  uploadDocuments(event: any) {
       if (event.target && event.target.files && event.target.files.length > 0) {
            Array.from(event.target.files).forEach((file: any) => {
                 if (file.name) {
                      const nameParts: string[] = file.name.split('.');
                      const fileExtension = nameParts[nameParts.length - 1].toLowerCase();
                      if (fileExtension === 'pdf' || fileExtension === 'jpg' || fileExtension === 'png' || fileExtension === 'jpeg') {
                           this.isValidFileType = true;
                           this.auditService.auditFiles.push(file);
                      } else {
                           this.isValidFileType = false;
                           this.invFileTypeModal = this.modalService.open(this.invalidFileTypeModal, { size: 'lg', ariaLabelledBy: 'invalidFileTypeModalTitle' });
                           event.target.value = '';
                           return;
                      }
                 }
            });
       } else if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length > 0) {
            Array.from(event.dataTransfer.files).forEach((file: any) => {
                 if (file.name) {
                      const nameParts: string[] = file.name.split('.');
                      const fileExtension = nameParts[nameParts.length - 1].toLowerCase();
                      if (fileExtension === 'pdf' || fileExtension === 'jpg' || fileExtension === 'png' || fileExtension === 'jpeg') {
                           this.isValidFileType = true;
                           this.auditService.auditFiles.push(file);
                      } else {
                           this.isValidFileType = false;
                           this.invFileTypeModal = this.modalService.open(this.invalidFileTypeModal, { size: 'lg', ariaLabelledBy: 'invalidFileTypeModalTitle' });
                           event.target.value = '';
                           return;
                      }
                 }
            });
       } else {
            // no files. User may have cancelled out of file windows file explorer when selecting file.
            event.target.value = '';
            return;
       }

    if (this.isValidFileType) {
        this.isUploading = true;
        this.auditService.uploadAuditDocuments(this.authCode, this.username, true)
            .then((result: any) => {
                if (result && result === 'unauthorized') {
                     console.error('User not authorized to upload audit documents.');
                     event.target.value = '';
                    this.router.navigateByUrl('/accessDenied');
                } else if (result && result.length > 0) {
                    result.forEach((result: any) => {
                        this.probationDocuments.push({
                            'created': result.created,
                            'creator': result.creator,
                            'documentId': result.documentId,
                            'fileName': result.fileName,
                            'mimeTypeId': result.mimeTypeId
                        });
                    });
                    this.auditService.auditFiles = [];
                    this.isUploading = false;
                }
                 event.target.value = '';
            }).catch((error: any) => {
                console.error('Error uploading audit documents');
                console.error(error);
                 this.isUploading = false;
                 event.target.value = '';
            });
    } else {
         event.target.value = '';
    }
  }

  closeInvalidFileTypeModal() {
      this.invFileTypeModal.close();
  }

  onFileUpload(event: any) {
      if (event.target && event.target.files && event.target.files.length > 0) {
          event.target.files.forEach((element:any) => {
              this.auditService.auditFiles.push(element);
          });
      } else if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length > 0) {
          event.dataTransfer.files.forEach((element:any) => {
              this.auditService.auditFiles.push(element);
          });
      }
  }

  submittalTypeChanged() {
      this.allowDocumentSubmissionContinue = true;
  }

  translate(translationTag: string) {
      let translatedText: string = this.generalService.getTranslation(translationTag, 'audit')
      if (translatedText === undefined) {
          translatedText = this.generalService.getTranslation(translationTag, 'audit');
      }
      return translatedText;
  }

}
